import {
  base_url,
  mockedBrand,
  mockedBuilding,
  mockedGetTokenizeCard,
  mockedHostInfo,
  mockedInitialRoute,
  mockedJWTToken,
  mockedTheme,
  mockedUser,
  sessionToken,
} from './mockedData';

export class MockedSdk {
  getJWT() {
    return mockedJWTToken;
  }

  getUser() {
    return mockedUser;
  }

  getBrand() {
    return mockedBrand;
  }

  getTheme() {
    return mockedTheme;
  }

  getInitialRoute() {
    return mockedInitialRoute;
  }

  init() {
    return {
      user: this.getUser(),
      building: this.getBuilding(),
      base_url,
      session_token: sessionToken,
      jwt_token: this.getJWT(),
      theme: this.getTheme(),
      brand: this.getBrand(),
      initial_route: this.getInitialRoute(),
    };
  }

  getBuilding() {
    return mockedBuilding;
  }

  getHostInfo() {
    return mockedHostInfo;
  }

  getTokenizeCard() {
    return mockedGetTokenizeCard;
  }

  getBuildings() {
    return [this.getBuilding()];
  }
}
